module.exports = __webpack_public_path__ + "static/media/logo.e11ebe8d.png";